import React from "react";
import * as C from "vonnegut.components";
import { observer, inject } from "mobx-react";
import ReactMarkdown from "react-markdown";
import * as Icon from "react-feather";

const SurveyViewWelcome = ({ store, survey }) =>
  survey && (
    <div className="flex justify-center items-center flex-col h-full p-16">
      <h1 className="center mb-8">
        <Icon.CheckSquare size={36} color="#444" />
      </h1>
      <h1 className="center color-primary mb-4">
        {store.$locale.t(survey._key + "_surveyName") || survey.name}
      </h1>
      {store.$locale.t(survey._key + "introText") && (
        <ReactMarkdown
          className="mt-4 lg-col-10 p-8 bg-white border-radius-large"
          source={store.$locale.t(survey._key + "introText")}
        />
      )}
      {store.$group.selected && (
        <div className="mt-4">
          <span>{store.$locale.t("survey_view_for_group")}&nbsp;</span>
          <b>{store.$group.selected.name}</b>
        </div>
      )}
      <React.Fragment>
        <C.Button
          className="bg-primary mt-8 medium mb-4"
          disabled={
            store.$config.hide_disclaimer !== true && store.$user.sessionUser.disclaimer === false
          }
          onClick={e => {
            const { $router, $survey, $user } = store;
            if (!$user.sessionUser.uid) {
              !$survey.selected && $survey.setSelected(survey._key);
              $user.change("registerForCluster", survey.cluster);
              $user.change("enableRegister", true);
            } else {
              $router.page !== "survey" &&
                $router.mode !== "view" &&
                $router.push(`/survey/view/${survey._key}`);
              $survey.selected.change("_disableWelcome", true);
            }
          }}
          icon={<Icon.Play />}
          label={store.$locale.t("start") || "start"}
        />

        {store.$survey.selected && !store.$config.hide_disclaimer && (
          <div className="flex items-center">
            <C.CheckboxNew
              name="multipleAnswers"
              checked={store.$user.sessionUser.disclaimer}
              onChange={e => {
                store.$user.sessionUser.change("disclaimer", !store.$user.sessionUser.disclaimer);
              }}
            />
            <span
              className="pointer underline"
              onClick={() => store.$user.sessionUser.change("showDisclaimerInfo", true)}
              dangerouslySetInnerHTML={{
                __html: store.$locale.t("disclaimer")
              }}
            />
          </div>
        )}
      </React.Fragment>
    </div>
  );

export default inject("store")(observer(SurveyViewWelcome));
